module.exports = __webpack_public_path__ + "static/img/team-7.bcad743.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/team-7.png
// module id = t5Zx
// module chunks = 1